import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

let Tile = ({ title, icon, path }) => (
  <Col md={3} sm={6} xs={12}>
    <Link to={path} className="thumbnail">
      <div className="caption">
        <div className="text-icon">
          <FontAwesome name={icon} size="3x" />
          <p className="cards">{title}</p>
        </div>
      </div>
    </Link>
  </Col>
)

class Main extends React.Component {
  render() {
    return (
      <Grid>
        <Row className="tiles">
          <Tile title="Klanten" icon="building-o" path="klanten" />
          <Tile title="Groepen" icon="users" path="groepen" />
          <Tile title="Gebruikers" icon="user" path="gebruikers" />
          <Tile title="Licenties" icon="key" path="licenties" />
        </Row>
        <Row className="tiles">
          <Tile title="Producten" icon="cube" path="producten" />
          <Tile title="Werkmaatschappijen" icon="university" path="werkmaatschappijen" />
          <Tile title="Orders" icon="file-text-o" path="orders" />
          <Tile title="IAM dashboard" icon="id-card-o" path="dashboard" />
        </Row>
      </Grid>
    )
  }
}

export default Main
